import React from 'react';
import { SideNavGroup } from '@amzn/aac-chrome-internal-api';
import {
  ExpandedListGroupTitle,
  ExpandedListItem,
  ExpandedListWrapper,
  SideGroupMobileDivider,
} from './styles';
import { renderFlag } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

interface MobileSideNavExpandedListProps {
  sidebarGroups: Array<SideNavGroup>;
  sidebarGroupTitle?: string;
}

const ExpandedMenuItemList: React.VFC<MobileSideNavExpandedListProps> = ({
  sidebarGroups,
  sidebarGroupTitle,
}) => {
  const items = sidebarGroups.map((group, groupIndex) => (
    <React.Fragment key={groupIndex}>
      {groupIndex > 0 && <SideGroupMobileDivider role="separator" />}
      {group.title &&
        group.title.length > 0 &&
        group.title !== sidebarGroupTitle && (
          <ExpandedListGroupTitle>{group.title}</ExpandedListGroupTitle>
        )}
      {group.links.map((sideNavLinkProp) => (
        <ExpandedListItem
          key={sideNavLinkProp.id}
          href={sideNavLinkProp.link.url}
          isSelected={sideNavLinkProp.isSelected}
          {...getTaktAttributes(sideNavLinkProp.id, chromeComponents.NAV, {
            url: sideNavLinkProp.link.url,
          })}
          data-ccx-e2e-id={sideNavLinkProp.id}
        >
          {sideNavLinkProp.link.label}
          {renderFlag(sideNavLinkProp, {
            isMobile: true,
            isInverted: true,
          })}
        </ExpandedListItem>
      ))}
    </React.Fragment>
  ));
  return <ExpandedListWrapper>{items}</ExpandedListWrapper>;
};

export default ExpandedMenuItemList;
